module.exports = __webpack_public_path__ + "img/feature_ly_bg.dcc88dac.png";